module.exports = __webpack_public_path__ + "static/img/interface.6b56eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus3/interface.png
// module id = Ovoj
// module chunks = 1